import Slider from 'components/3catinfo/Slider';
import Autor from '../Autor';
import styles from './tiraFirmes.module.scss';

const TiraFirmes = (props) => {
    const {
        items,
        priorityImage = false,
        textBotoMes,
        mostrarCarrec = false,
        mostrarSegueix = false,
        numLimitedItems = 6,
        mostrarBotoMesItems = true,
        tipus = 'analisi'
    } = props;

    const itemsShow = [...items.slice(0, numLimitedItems)];

    let formatSlider = 'tira_analisi_firmes';
    let estilAutor = 'tiraAnalisiAutor';
    let estilSlider = 'tiraAnalisiFirmes';
    if (tipus === 'autors') {
        formatSlider = 'tira_autors';
        estilAutor = 'tiraAutors';
        estilSlider = 'tiraAutors';
    }

    return (
        <div className={styles.contentTirarFirmes}>
            {items && (
                <Slider
                    key={`tira-firmes-${formatSlider}`}
                    format={formatSlider}
                    estilModul={estilSlider}
                    mostrarBotoMesItems={mostrarBotoMesItems}
                    propsEnllac={{ linkTipus: 'web_actualitat_seccio', slug: 'firmes' }}
                    textBotoMes={textBotoMes}
                    fletxes='mig'
                >
                    {itemsShow.map((item) => (
                        <Autor
                            format='autor'
                            key={`firma-tira-firma-${item.id}`}
                            item={item}
                            estil={estilAutor}
                            mostrarCarrec={mostrarCarrec}
                            mostrarSegueix={mostrarSegueix}
                            priorityImage={priorityImage}
                        />
                    ))}
                </Slider>
            )}
        </div>
    );
};

export default TiraFirmes;
